export default __webpack_public_path__ + "img/bNSnrmLx.420b193d.svg";